import { makeStyles } from '@material-ui/core';

import { neutral, red } from 'shared/styles/colors';

export default makeStyles(() => ({
  checkCodeContainer: ({ hasTurboUrgency }: Props) => ({
    borderRadius: '62.5rem',
    background: hasTurboUrgency ? red[60] : neutral.D10,
  }),
  checkCode: ({ hasTurboUrgency }: Props) => ({
    color: hasTurboUrgency ? neutral.white : neutral.D18,
    fontSize: '0.75rem',
    fontWeight: 600,
  }),
}));

interface Props {
  hasTurboUrgency: boolean;
}
